'use client';

import { ClerkProvider } from '@clerk/nextjs';
import { dark } from '@clerk/themes';
import { ReactNode } from 'react';
import { useTheme } from 'next-themes';

export default function ClerkClientWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const { resolvedTheme } = useTheme();

  return (
    <ClerkProvider
      afterSignOutUrl='/'
      appearance={{
        baseTheme: resolvedTheme === 'dark' ? dark : undefined,
        elements: {
          formButtonPrimary:
            'bg-linear-to-r from-blue-500 to-emerald-500 hover:from-blue-600 hover:to-emerald-600 text-white transition-all hover:scale-105',
          footerActionLink: 'text-blue-400 hover:text-blue-300',
          card: 'bg-transparent border-none shadow-none',
          formInput:
            'bg-gray-800/40 border-gray-700/50 text-white rounded-lg focus:ring-2 focus:ring-blue-500/20',
          formLabel: 'text-gray-200',
          identityPreviewEditButton: 'text-blue-400 hover:text-blue-300',
          alertText: 'text-gray-200',
          socialButtonsBlockButton:
            'border border-gray-700 hover:border-gray-600 text-gray-200 hover:bg-gray-800/50',
          socialButtonsBlockButtonText: 'text-gray-200',
          formFieldAction: 'text-blue-400 hover:text-blue-300',
          formFieldSuccessText: 'text-emerald-500',
          otpCodeFieldInput: 'bg-gray-800 border-gray-700 text-white',
          dividerLine: 'bg-gray-700',
          dividerText: 'text-gray-400',
        },
      }}
    >
      {children}
    </ClerkProvider>
  );
}
